// extracted by mini-css-extract-plugin
export default {"SecondaryHeaderMain":"secondaryHeader_SecondaryHeaderMain__Jql-0","editButton":"secondaryHeader_editButton__jMUOY"};